import React, { useState, useEffect, useContext, useCallback } from 'react';
import axios from 'axios';
import API_BASE_URL from '../../config/api';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import { motion } from 'framer-motion';
import { AuthContext } from '../../context/AuthContext';

const AdminQuizListPage = () => {
    const [quizzes, setQuizzes] = useState([]);
    const { token } = useContext(AuthContext);

    const fetchQuizzes = useCallback(async () => {
        try {
            const config = { headers: { 'x-auth-token': token } };
            const res = await axios.get(`${API_BASE_URL}/api/quizzes`, config);
            setQuizzes(res.data);
        } catch (err) {
            toast.error("Failed to load quizzes.");
        }
    }, [token]);

    useEffect(() => {
        if (token) fetchQuizzes();
    }, [token, fetchQuizzes]);

    const handleDelete = async (quizId) => {
        if (window.confirm('Are you sure you want to delete this quiz?')) {
            try {
                const config = { headers: { 'x-auth-token': token } };
                await axios.delete(`${API_BASE_URL}/api/quizzes/${quizId}`, config);
                toast.success('Quiz successfully deleted!');
                fetchQuizzes();
            } catch (err) {
                toast.error('An error occurred while deleting quiz.');
            }
        }
    };

    return (
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="card p-8">
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-3xl font-bold">Quiz Management</h1>
                <Link to="/admin/add-quiz" className="bg-green-500 text-white font-bold py-2 px-4 rounded hover:bg-green-600">
                    Add New Quiz
                </Link>
            </div>
            <div className="overflow-x-auto">
                <table className="w-full text-left">
                    <thead><tr className="border-b-2"><th className="p-3">Quiz Title</th><th className="p-3">Related Course</th><th className="p-3">Number of Questions</th><th className="p-3">Actions</th></tr></thead>
                    <tbody>
                        {quizzes.map(quiz => (
                            <tr key={quiz._id} className="border-b">
                                <td className="p-3">{quiz.title}</td>
                                <td className="p-3">{quiz.courseId ? quiz.courseId.title : 'Unlinked'}</td>
                                <td className="p-3">{quiz.questions.length}</td>
                                <td className="p-3 flex gap-2">
                                    <Link to={`/admin/edit-quiz/${quiz._id}`} className="bg-blue-500 text-white px-3 py-1 rounded text-sm hover:bg-blue-600">Edit</Link>
                                    <button onClick={() => handleDelete(quiz._id)} className="bg-red-500 text-white px-3 py-1 rounded text-sm hover:bg-red-600">Delete</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </motion.div>
    );
};

export default AdminQuizListPage;